import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { Link } from "../Link";

interface Props {
  title: string | Ii18nInterpolationObject;
  path: string;
}

export const MenuItem: FC<Props> = ({ title, path }) => {
  const { t } = useTranslation();

  const menuTitle = typeof title === "string" ? title : t(title.i18nKey);

  return (
    <li className="h-full text-nowrap">
      <Link
        className="flex items-center h-full hover:brightness-130 hover:scale-105"
        href={path}
      >
        {menuTitle}
      </Link>
    </li>
  );
};
